import { UPDATE_GIFTCARD_LIST } from 'actions/MyAccountActions/giftCardActions';

export default function updateGiftList(state = {}, action = {}) {
	switch (action.type) {
		case UPDATE_GIFTCARD_LIST:
			return Object.assign({}, state, {
				data: action.data
			});
		default:
			return state;
	}
}
